( function () {
   
    'use strict';

    ( function ( $ ) {
        $(document).ready(function(){
            var group = $(".buytickets-admission-price-list");
            var tallest = 0;
            group.each(function(){
              var currentHeight = $(this).height();
              if(currentHeight > tallest) {
                 tallest = currentHeight;
              }
          });
          group.height(tallest);
        });


    
        
    } )( jQuery );
} )();

